import { Observable, Subject, EMPTY } from 'rxjs';
import { filter, takeUntil, finalize } from 'rxjs/operators';

import { Injectable, OnDestroy } from '@angular/core';
import { Params, Router } from '@angular/router';

import { SnAppliance } from '@lib/api/entities';
import { SnDrawerService } from '@lib/ui/drawer';

import { ApplianceFormDrawerComponent } from '../components/appliance-form-drawer/appliance-form-drawer.component';

@Injectable({
  providedIn: 'root',
})
export class ApplianceOperationsService implements OnDestroy {
  constructor(private readonly _drawer: SnDrawerService, private readonly _router: Router) {}

  private readonly _destroy$ = new Subject<void>();
  private _isDrawerOpen = false;

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  editAppliance(targetAppliance: SnAppliance): Observable<SnAppliance> {
    if (this._isDrawerOpen) {
      return EMPTY;
    }
    this._isDrawerOpen = true;

    return this._drawer
      .open(ApplianceFormDrawerComponent, {
        width: 320,
        data: targetAppliance,
      })
      .afterClosed$.pipe(
        filter((response) => !!response),
        takeUntil(this._destroy$),
        finalize(() => {
          this._isDrawerOpen = false;
        }),
      );
  }

  viewAppliance(targetAppliance: SnAppliance): void {
    const id: string = targetAppliance.id;
    const queryParams: Params = { appliance: id };
    this._router.navigate(['/appliances/list/appliance'], { queryParams });
  }
}
